function isFilterValueSet<V>(value: V): boolean {
    if (value === null || value === undefined || value === "") {
        return false;
    }
    if (Array.isArray(value)) {
        return value.length > 0;
    }
    return true;
}

export function hasActiveListFilters<T extends Record<string, unknown>>(
    filters: T | undefined,
): boolean {
    return Object.values(filters ?? {}).some(isFilterValueSet);
}
